import { Component, EventListener, triggerPublicEvent } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';

enum States {
	HasFile = 'state-m-file-upload--has-file',
}

enum Selectors {
	FileUploadInput = '.js-m-file-upload__button-input',
	UploadedFile = '.js-m-file-upload__selected-file-name',
	DeleteUploadedFile = '.js-m-file-upload__selected-file-remove',
}

@Component('FileUpload')
export class FileUpload extends GondelJqueryComponent {
	private $fileUploadInput: JQuery<HTMLElement>;

	public start() {
		this.$fileUploadInput = this.$ctx.find(Selectors.FileUploadInput);
	}

	public sync() {
		this.$fileUploadInput.one('focus', () => triggerPublicEvent('gFormInteractionEvent', this));
	}

	public getFileValidationData(): string {
		let validationData = '';
		const file = this.getFileFromInput();

		if (file) {
			validationData = `${this.$fileUploadInput.attr('name')}=${file.name};${file.size};${file.type}`;
		}

		return validationData;
	}

	public getFile(): File {
		return this.getFileFromInput();
	}

	@EventListener('change', Selectors.FileUploadInput)
	private _handleFileUpload() {
		const file = this.getFileFromInput();

		if (file) {
			this.$ctx.find(Selectors.UploadedFile).html(file.name.trim());
			this.toggleDeleteIconClass(true);
		}
	}

	@EventListener('click', Selectors.DeleteUploadedFile)
	private _handleDeleteUploadedFile() {
		this.$ctx.find(Selectors.UploadedFile).text('');
		this.$fileUploadInput.val('');
		this.toggleDeleteIconClass(false);
	}

	private toggleDeleteIconClass(state: boolean) {
		this.$ctx.toggleClass(States.HasFile, state);
	}

	private getFileFromInput(): File {
		const input = this.$fileUploadInput[0] as HTMLInputElement;
		const files = input.files as FileList;

		return files.item(0) as File;
	}
}
